"use client";

import branch from "branch-sdk";
import config from "@/config";

export const initBranch = (onSuccess = () => {}, onError = () => {}) => {
	console.log("initBranch", config.branch.key);
	const options = {};
	branch.init(config.branch.key, options, (err, data) => {
		if (err) {
			console.error("Branch init error", err);
			onError(err);
		} else {
			console.log("Branch init success", data);
			onSuccess(data);
		}
	});
};
